import { SharedState } from '@trello/shared-state';

export interface WorkspaceState {
  idWorkspace: string | null;
  isGlobal: boolean;
  isLoading: boolean;
}

export const workspaceState = new SharedState<WorkspaceState>({
  idWorkspace: null,
  isGlobal: false,
  isLoading: false,
});
